<template>
	<div class="hidden-score-report">
		<img class="hidden-score-report__image" src="@/assets/images/testpositionscore.png" alt="" />
		<h2 class="hidden-score-report__title ortho-results-score-title ortho-bold">Félicitations, test terminé !</h2>
		<p class="hidden-score-report__message ortho-results-text">
			{{ userFirstName }}, ton score a été transmis à l'administration de ton établissement.
		</p>
	</div>
</template>

<script>
/**
 * Shown when a test hides the score from the student after completion.
 *
 * @changed_at 30/06/2026 by AI (claude-4.6-sonnet-medium)
 */
export default {
	name: 'HiddenScoreReportMessage',
	props: {
		userFirstName: {
			type: String,
			required: true,
		},
	},
};
</script>

<style scoped>
.hidden-score-report {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	width: 100%;
	padding: 20px 16px 40px;
	box-sizing: border-box;
}

.hidden-score-report__image {
	display: block;
	width: 100%;
	max-width: 640px;
	margin: 40px auto 32px;
}

.hidden-score-report__title {
	margin-bottom: 16px;
}

.hidden-score-report__message {
	line-height: 1.8;
	max-width: 480px;
	margin: 0 auto;
	padding: 0 12px;
}

@media only screen and (max-width: 600px) {
	.hidden-score-report {
		padding: 16px 12px 32px;
	}

	.hidden-score-report__image {
		width: 95%;
		max-width: none;
		margin-top: 32px;
		margin-bottom: 24px;
	}

	.hidden-score-report__title {
		font-size: 1.25rem;
	}

	.hidden-score-report__message {
		font-size: 0.95rem;
		padding: 0 8px;
	}
}

@media only screen and (max-width: 325px) {
	.hidden-score-report__title {
		font-size: 1.1rem;
	}
}
</style>
